import { forwardRef } from 'react';
import MuiBox, { BoxProps } from '@mui/material/Box';

export const Box = forwardRef<HTMLElement, BoxProps>(function Box(
  { children, ...props },
  ref,
) {
  return (
    <MuiBox ref={ref} {...props}>
      {children}
    </MuiBox>
  );
});

export type { BoxProps };
